module.exports = __webpack_public_path__ + "static/media/logoSemFundo.d7459e13.png";